import { useHttpClient } from "@/common/api/httpClient";
import type { LogSorterResponse } from "./common/logSorterResponse";
import type { LogSorterBin } from "./common/logSorterBin";
import { useLanguageStore } from "shared/translations/stores/languageStore";
import { storeToRefs } from "pinia";

export interface UpdateLogSorterRequest {
  id: number;
  logSorter: LogSorter;
}

export interface LogSorter {
  name: string;
  intakes: string[];
  bins: LogSorterBin[];
  addLogWhenSorted: boolean;
  configuration: string;
}

export interface UpdateLogSorterResponse {
  ok: true;
  logSorter: LogSorterResponse;
}

export function useUpdateLogSorter() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute
  };

  async function execute(action: UpdateLogSorterRequest) {

    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl(`logsorter/${action.id}`), {
      headers,
      method: 'put',
      body: JSON.stringify(action.logSorter)
    });

    const text = translations.value.logSorter.actions.update;

    const response = await httpClient.action<UpdateLogSorterResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk(response) {
        const json = await response.json() as LogSorterResponse;

        return {
          ok: true,
          logSorter: json
        };
      },
    });

    return response;
  }
}
